import { createSlice } from "@reduxjs/toolkit";

const hardwareDataSlice = createSlice({
  name: "hardware",
  initialState: { hardware: [] },
  reducers: {
    getHardware(state, actions) {
      state.hardware = actions.payload;
    },
  },
});

export const hardwareDataActions = hardwareDataSlice.actions;
export default hardwareDataSlice;
